import React, { Component } from "react";
import { LoginForm } from "./../../components/LoginForm/LoginForm";
import api from "../../utils/api";
import {
    storeAccessToken,
    storeUser,
    getUser,
    storeServiceTypesMaster,
    storeStatesMaster,
    getCookie,
    storeESPUser,
  } from "../../utils/localStorage";
  // import axios from "axios";
  import axios from "./../../utils/axios";
  // import values from 'lodash/values';
  import Cookies from "universal-cookie";
  import { toast } from "react-toastify";
  import Spinner from "../../common/Spinner/Spinner";
  import PropTypes from "prop-types";
  import "../../components/LoginForm/LoginForm.scss";
  import { Input } from "../../common/Input/Input";
  import { Button } from "../../common/Button/Button";
  import logo from "./../../assets/logo.png";
  import { SELECTED_SIDE_BAR_ITEM_KEY } from "../../common/SidebarContent/SidebarContent";


class AuthenticateExternalSP extends Component
{
    constructor(props) 
    {
        super(props);
        this.state = 
        {
          error: null,
          isLoading:false,
          key:''
        };
    }

    componentWillMount()
    {
      //const { key } = this.props.match.params; 
      const authResult = new URLSearchParams(window.location.search); 
      const key = authResult.get('key');
      this.setState({key:key});
      const cookies = new Cookies();
      localStorage.clear();
      cookies.remove('token', { path: '/', domain: '.deasra.in'}); 
    }

     componentDidMount()
    {
        //this.props.history.push("/service_partner/service-requests");
        //const { key } = this.props.match.params;   
        const authResult = new URLSearchParams(window.location.search); 
        const key = authResult.get('key');  
        if(key)
        {
          //var ts=encodeURIComponent(`iqljetZeSP8vedYqw/elko8WVNIlsQjqP3g1LrRxVLE=`)
          //var DKey=decodeURIComponent(key);
          var DKey=decodeURIComponent(key);
          
          this.setState({key:key});
          let paylod=  { key:DKey};
          this.setState({isLoading:true}); 
          api.sendOTPToESP(paylod)
          .then((response) => 
          {
            var d=response;
            this.setState({isLoading:false});
              if (response.status == 201)
              {
                if(response.data.message)
                {
                    toast(response.data.message, {
                        autoClose: 5000,
                        type: toast.TYPE.SUCCESS,
                    });
                }
                else
                {
                    toast("OTP is send to your registered email address and mobile number", {
                      autoClose: 5000,
                      type: toast.TYPE.SUCCESS,
                    });
                }
              }
              else if(response.status == 401)
              {
                  if(response.data.message)
                  {
                      toast(response.data.message, {
                          autoClose: 5000,
                          type: toast.TYPE.ERROR,
                      });
                  }
                  else if(response.data.detail)
                  {
                      toast("Error while sending OTP", {
                          autoClose: 5000,
                          type: toast.TYPE.ERROR,
                      });
                  }
              }
              else
              {
                  toast("Internal server error.", {
                      autoClose: 5000,
                      type: toast.TYPE.ERROR,
                  });
              }
          })
          .catch((error) => {
            this.setState({isLoading:false});
            if (error.response) {
              if(error.response.data.message)
                  {
                      toast(error.response.data.message, {
                          autoClose: 5000,
                          type: toast.TYPE.ERROR,
                      });
                  }
            }
          });
        }
        else
        {
          /*toast("Invalid URL.", {
            autoClose: 5000,
            type: toast.TYPE.ERROR,
          });*/
        }
        
    }

    handleInputChange = ({ name, value }) => {
        this.setState({ [name]: value });
    };

    handleSubmitOTPClick = () => {
      //const { key } = this.props.match.params;
      const authResult = new URLSearchParams(window.location.search); 
      const key = authResult.get('key');
      this.setState({isLoading:true});
      const { OTP } = this.state;
      var DKey=decodeURIComponent(key);
      let paylod=  { key:DKey,otp:OTP};

      api.loginESPWithOTP(paylod)
          .then((response) => 
          {
            var d=response;
            this.setState({isLoading:false});
              if (response.status == 201||response.status == 200)
              {
                this.handlePostLoginSuccess(response.data);
              }
              else if(response.status == 401)
              {
                  if(response.data.message)
                  {
                      toast(response.data.message, {
                          autoClose: 5000,
                          type: toast.TYPE.ERROR,
                      });
                  }
                  else if(response.data.detail)
                  {
                      toast("OTP is invalid", {
                          autoClose: 5000,
                          type: toast.TYPE.ERROR,
                      });
                  }
              }
              else
              {
                  toast("Internal server error.", {
                      autoClose: 5000,
                      type: toast.TYPE.ERROR,
                  });
              }
          }).catch((error) => {
            this.setState({isLoading:false});
            if (error.response) {
              if(error.response.data.message)
                  {
                      toast(error.response.data.message, {
                          autoClose: 5000,
                          type: toast.TYPE.ERROR,
                      });
                  }
            }
          });
    };

  handlePostLoginSuccess = async (data) => {
    const { token } = data;
    const cookies = new Cookies();
    cookies.set("token", "Token " + data["token"], {
      path: "/",
      domain: ".deasra.in",
    });
    storeESPUser(data);
    storeAccessToken(token);
    this.setState({ isLoading: false });

    if (data.email === "marketconnect@deasra.co.in") {
      localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/service_partner/service-requests");
      this.props.history.push("/service_partner/service-requests");
    } else {
      localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/service_partner/dashboard");
      this.props.history.push("/service_partner/dashboard");
    }
    
  };

    render() {
        return (
          <>
          {this.state.key?
          (
            <>
                <div className={`login-container ${this.state.isLoading && "set-opacity"}`}>
                <div className="login-form-container">
                  <div className="login-form text-center">
                    <div className="text-center mt10 mb20">
                      <img alt="deasra-logo" src={logo} className="h40 mb20 logo-img"/>
                    </div>
                    {this.state.isLoading && <Spinner className="center-screen" />} 
                    {/*<Input
                      className="username"
                      name="username"
                      placeholder="Username"
                      onChange={({ target }) => this.handleInputChange(target)}
                      readOnly={this.state.isOTPSent}
                    />*/}
                    <Input
                      type="username"
                      name="OTP"
                      className="username"
                      placeholder="Enter OTP"
                      //readOnly={!this.state.isOTPSent}
                      onChange={({ target }) => this.handleInputChange(target)}
                    />
                    {this.state.error ? (<div className="form-error">{this.props.error}</div>) : null}
                    <div className="flex justify-content-stretch mt20" style={{marginBottom:"50px"}}>
                      <Button className="w100p pt10 pb10" primary onClick={this.handleSubmitOTPClick}>
                        {"Verify OTP"}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                  <div className="text-center">
                    <div className="d-inline-flex">
                      <div className="mr5">
                        <a href="http://www.deasra.in">Help</a>
                      </div>
                      <div className="ml5">
                        <a href="http://www.deasra.in">Contact Us</a>
                      </div>
                    </div>
                    <div>
                      <span>© 2020 deAsra Foundation. </span>
                      <a
                        className="text-help"
                        href="http://www.deasra.in"
                        target="_blank"
                        rel="noopener noreferrer"
                      ></a>
                    </div>
                  </div>
              </div>
            </>
          ):
          (
            <>
            <div className={`login-container ${this.state.isLoading && "set-opacity"}`}>
              <div className="login-form-container">
                <div className="login-form text-center">
                  <span>Your session is expired please login</span>
                </div>
              </div>
            </div>
            <div>
                <div className="text-center">
                  <div className="d-inline-flex">
                    <div className="mr5">
                      <a href="http://www.deasra.in">Help</a>
                    </div>
                    <div className="ml5">
                      <a href="http://www.deasra.in">Contact Us</a>
                    </div>
                  </div>
                  <div>
                    <span>© 2020 deAsra Foundation. </span>
                    <a
                      className="text-help"
                      href="http://www.deasra.in"
                      target="_blank"
                      rel="noopener noreferrer"
                    ></a>
                  </div>
                </div>
            </div>
          </>
          )
          }
            
        </>
        );
      }
}
export default AuthenticateExternalSP;